import React, { useMemo } from 'react'
import { cdnUrl } from 'commons/cdn'
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import Skeleton from '@/components/ui/skeleton'

import { cn } from '@/lib/utils'
import { pickerGridCards } from 'Editor/lib/visibleComponents'
import { useParams } from 'react-router-dom'
import { useUI } from 'Editor'
import { SortableCptGrid } from './SortableCptGrid'
import { UploadingCptCards } from '../BatchUpload/UploadingCptCard'
import { jobMatchesLayer, useCptUploadStore } from '../BatchUpload/uploadQueue'

export const DefalutCpts = ({ cpts }) => {
  const { tid } = useParams()
  const lid = useUI((state) => state.lid)

  const data = useMemo(
    () => cpts?.filter((cpt) => cpt.dlc === tid),
    [cpts, tid],
  )
  return (
    <AccordionItem value={tid}>
      <AccordionContent className="pt-1 pb-1">
        <SortableCptGrid
          cpts={data}
          stackCpts={data}
          uploading={<UploadingCptCards tid={tid} lid={lid} dlc={tid} />}
        />
      </AccordionContent>
    </AccordionItem>
  )
}

export const CptsWithoutDlc = ({ cpts }) => {
  const { tid } = useParams()
  const lid = useUI((state) => state.lid)
  const data = useMemo(() => cpts?.filter((cpt) => !cpt.dlc), [cpts])
  const uploadingCount = useCptUploadStore(
    (s) =>
      s.jobs.filter(
        (job) =>
          job.tid === tid && jobMatchesLayer(job, lid) && !job.dlc,
      ).length,
  )
  const cardCount = pickerGridCards(data).length + uploadingCount
  if (cardCount === 0) {
    return null
  }
  return (
    <AccordionItem value={'withoutdlc'}>
      <AccordionTrigger>
        <div className="text-destructive">
          Miss DLC, please add DLC - ({cardCount})
        </div>
      </AccordionTrigger>
      <AccordionContent>
        <SortableCptGrid
          cpts={data}
          uploading={<UploadingCptCards tid={tid} lid={lid} dlc="" />}
        />
      </AccordionContent>
    </AccordionItem>
  )
}

export const CptsInDlc = ({ dlc, cpts, isLast }) => {
  const { tid } = useParams()
  const lid = useUI((state) => state.lid)
  const _cpts = useMemo(
    () => cpts?.filter((cpt) => cpt.dlc === dlc.id),
    [cpts, dlc.id],
  )
  const uploadingCount = useCptUploadStore(
    (s) =>
      s.jobs.filter(
        (job) =>
          job.tid === tid &&
          jobMatchesLayer(job, lid) &&
          job.dlc === dlc.id,
      ).length,
  )
  const cardCount = pickerGridCards(_cpts).length + uploadingCount
  return (
    <AccordionItem
      value={dlc.id}
      className={cn(isLast && 'border-b-transparent')}
    >
      <AccordionTrigger>
        <div className="flex items-center gap-2 ml-2">
          {dlc.cover ? (
            <img className="w-12 h-12" src={cdnUrl(dlc.cover)} alt="dlc icon" />
          ) : (
            <Skeleton className="w-12 h-12">DLC ICON</Skeleton>
          )}
          <span className="text-bold text-lg">{dlc.name}</span>
          <span className="text-xs">cpts:{cardCount}</span>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        <SortableCptGrid
          cpts={_cpts}
          stackCpts={cpts}
          uploading={<UploadingCptCards tid={tid} lid={lid} dlc={dlc.id} />}
        />
      </AccordionContent>
    </AccordionItem>
  )
}
